import TestError from './errors/test';
import auth from './errors/auth';
import review from './errors/review';
import campaignSignUpHelper from './errors/campaign-sign-up-helper';
import signUpHelpee from './errors/sign-up-helpee';
import userDashboardAuth from './errors/user-dashboard/auth';
import userDashboardPublic from './errors/user-dashboard/public';
import userDashboardReferral from './errors/user-dashboard/referral';
import userDashboardChallenge from './errors/user-dashboard/challenge';
import userDashboardSupport from './errors/user-dashboard/support';
import userDashboardRelation from './errors/user-dashboard/relation';
import adminSaasDashboard from './errors/admin-saas/dashboard';
import adminSaasCampaign from './errors/admin-saas/campaign';
import adminSaasReview from './errors/admin-saas/review';
import adminSaasReviewIntegration from './errors/admin-saas/review-integration';
import adminSaasCampaignCampaignHelpee from './errors/admin-saas/campaign/campaign-helpee';
import adminSaasCampaignCampaignHelper from './errors/admin-saas/campaign/campaign-helper';
import adminSaasCampaignCampaignEditHelper from './errors/admin-saas/campaign/campaign-edit-helper';
import adminSaasAmbassador from './errors/admin-saas/ambassador';
import adminSaasChallenge from './errors/admin-saas/challenge';
import adminSaasUserChallenge from './errors/admin-saas/user-challenge';
import adminSaasCustomerOnboarding from './errors/admin-saas/customer-onboarding';
import adminSaasAuth from './errors/admin-saas/auth';
import adminSaasInterconnection from './errors/admin-saas/interconnection';
const allErrors = {
    "GENERIC": {
        "TEST_NOT_FOUND": {
            actionType: 'message',
            message: {
                fr: "The requested resource was not found.",
                en: "La ressource demandée n'a pas été trouvée.",
            },
        },
    },
    ...TestError,
    ...campaignSignUpHelper,
    ...adminSaasDashboard,
    ...adminSaasCampaign,
    ...adminSaasAuth,
    ...adminSaasInterconnection,
    ...userDashboardAuth,
    ...userDashboardPublic,
    ...auth,
    ...userDashboardReferral,
    ...adminSaasReview,
    ...adminSaasReviewIntegration,
    ...review,
    ...adminSaasCampaignCampaignHelpee,
    ...adminSaasCampaignCampaignHelper,
    ...adminSaasCampaignCampaignEditHelper,
    ...adminSaasAmbassador,
    ...adminSaasChallenge,
    ...adminSaasUserChallenge,
    ...userDashboardChallenge,
    ...userDashboardSupport,
    ...signUpHelpee,
    ...adminSaasCustomerOnboarding,
    ...userDashboardRelation,
    // "UNAUTHORIZED_ACCESS": {
    //     actionType: 'redirect',
    //     redirectPath: '/login',
    //     message: {
    //         fr: "Vous devez être connecté pour accéder à cette ressource.",
    //         en: "You must be logged in to access this resource."
    //     }
    // },
    // "ADMIN_SAAS_CHALLENGE_NOT_FOUND": {
    //     actionType: 'toast',
    //     message: {
    //         fr: 'Le challenge n\'a pas été trouvé.',
    //         en: 'The challenge was not found.'
    //     }
    // },
    // V2 for message in form
    // "ADMIN_SAAS_CHALLENGE_NOT_FOUND_2": { // V2
    //     actionType: 'message',
    //     ids: ['email', 'firstname'],
    //     message: {
    //         fr: 'Le challenge n\'a pas été trouvé.',
    //         en: 'The challenge was not found.'
    //     }
    // },
};
const _fallbackError = {
    actionType: 'toast',
    message: {
        en: "An unknown error occurred.",
        fr: "Une erreur inconnue est survenue.",
    },
};
const findError = (type, subtype) => {
    const errorByType = allErrors[type];
    if (!errorByType) {
        const genericError = allErrors['GENERIC'];
        return genericError?.[subtype] || _fallbackError;
    }
    return errorByType[subtype] || _fallbackError;
};
export { findError, allErrors, };
